<template>
  <div class="threeSolidHome">
    <div class="cqmap">
      <cqmap />
    </div>

    <div class="car">
      <div class="itemcard" v-for="itme in petsonlist" :key="itme.id">
        <span class="itemcardtitle">{{ itme.value }}</span>
        <span class="itemcardnum">{{ itme.num }}</span>
      </div>
    </div>

    <div class="home-content">
      <populationLeft></populationLeft>
      <populationRight></populationRight>
    </div>
  </div>
</template>
<script>
import { defineComponent, ref, reactive, toRefs } from "vue";
import populationLeft from "./components/populationLeft";
import populationRight from "./components/populationRight";
import {
  region,
  count,
  populationType,
} from "@/api/dataAnalysis/populationAnalysis.js";
import { getDict } from "@/api/constant";
import cqmap from "../map.vue";
export default defineComponent({
  name: "",
  components: {
    populationLeft,
    populationRight,
    cqmap,
  },
  props: {
    cpn: {
      type: String,
      default: "",
    },
  },
  setup(props) {
    const state = reactive({
      regionId: 0,
      value: "",
      petsonlist: [],
    });
    const refData = toRefs(state);
    const list = reactive([
      { id: 0, title: "人口分析", conponent: "housingAnalysis" },
      { id: 1, title: "房屋分析", conponent: "populationAnalysis" },
      { id: 2, title: "单位分析", conponent: "unitOfAnalysis" },
      { id: 3, title: "事件分析", conponent: "eventAnalysis" },
      { id: 4, title: "告警分析", conponent: "warningAnalysis" },
    ]);
    const petsonlist = reactive([
      { id: 0, title: "人员总数", num: 0 },
      { id: 1, title: "本地户籍", num: 0 },
      { id: 2, title: "外来人口", num: 0 },
      { id: 3, title: "境外来华人员", num: 0 },
      { id: 4, title: "未落户人员", num: 0 },
      { id: 5, title: "其他", num: 0 },
      // { id: 6, title: "实有车辆", num: 3334 },
      // { id: 7, title: "实有车辆", num: 3334 }
    ]);
    const options = reactive([]);
    // 获取数据字典
    const queryMenuType = async () => {
      const res = await getDict("populationType");

      state.petsonlist = res.dict;
      state.petsonlist.unshift({ id: 0, value: "人员总数", num: 0 });
    };
    queryMenuType();
    // 实有人口 地区分布
    const regionlist = async () => {
      const res = await region();
      state.regionId = res.data[0].regionInfo.regionId;
      localStorage.setItem("regionId", state.regionId);
    };
    // 实有人口 人口总数
    const countlist = async () => {
      const res = await count(state.regionId);
      state.petsonlist.forEach((v) => {
        if (v.id === 0) {
          v.num = res.data.value;
        } else {
          v.num = 0;
        }
      });
    };
    // 实有人口 本地户籍
    const populationTypelist = async () => {
      const res = await populationType(state.regionId);
      state.petsonlist.forEach((v) => {
        res.data.forEach((j) => {
          if (j.id == v.code) {
            v.num = j.value;
          }
        });
      });
    };
    regionlist();
    countlist();
    populationTypelist();

    return {
      list,
      options,
      ...refData,
      regionlist,
    };
  },
});
</script>
<style lang="scss" scoped>
.threeSolidHome {
  background: url("~@/assets/images/threeSolid/threebg.png");
  height: 100%;
  width: 100%;
  position: relative;
  .cqmap {
    position: relative;
    top: 0;
    left: 0;
    width: 500px;
    height: 500px;
  }
  .car {
    z-index: 3;
    width: 1050px;
    height: 210px;
    background-image: url("~@/assets/images/0303/box.png");
    background-repeat: no-repeat;
    position: absolute;
    bottom: -100px;
    left: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
    align-items: center;
    box-sizing: border-box;
    padding: 10px 170px;
    .itemcard {
      margin-right: 15px;
      width: 165px;
      height: 70px;

      background-image: url("~@/assets/images/0303/cardbg.png");
      background-repeat: no-repeat;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      align-items: center;
      .itemcardtitle {
        color: #fff;
        font-size: 18px;
        font-weight: 700;
        text-align: center;
      }
      .itemcardnum {
        color: #23fffc;
        font-size: 16px;
        font-weight: 700;
      }
    }
  }
  .selectarea {
    background-color: rgba(0, 0, 0, 0.3);
    background-repeat: no-repeat;
    position: absolute;
    bottom: 195px;
    left: 39%;
    transform: translate(-50%, -50%);
    display: flex;
    align-items: center;
    justify-content: space-between;
    z-index: 5;
    padding: 10px;
    box-sizing: border-box;
    ::v-deep .el-select {
      margin-right: 15px !important;
    }
    .selectareaitme {
      z-index: 5;
    }
    ::v-deep .el-input__inner {
      background-color: #065080 !important;
      outline: none !important;
      border: none !important;
      .el-range-separator {
        color: #fff !important;
      }
      input {
        background-color: #065080 !important;
        color: #fff !important;
      }
    }
  }
  .btn {
    position: relative;
    color: #fff;
    width: 145px;
    height: 50px;
    background-color: rgba(255, 255, 255, 0);
    background-image: url("~@/assets/images/0303/menu2.png");
    background-repeat: no-repeat;
    &.active {
      color: #fff;
      width: 145px;
      height: 50px;
      background-color: rgba(255, 255, 255, 0);
      background-image: url("~@/assets/images/0303/menu1.png");
      background-repeat: no-repeat;
    }
  }
  .cqmap {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: 0 auto;
    z-index: 2;
  }
  .home-content {
    height: 100%;
    width: 100%;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 3;
    pointer-events: none;
    display: flex;

    .home-left {
      pointer-events: auto;
    }
  }
}
</style>
